var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h2", [_vm._v("Configure Parameter")]),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { staticClass: "alert alert-info" }, [
          _c("img", { attrs: { src: "/static/drip.svg" } }),
          _vm._v("Loading data..."),
        ])
      : _c("div", [
          _c("div", { staticClass: "form-group" }, [
            _c("label", [_vm._v("Parameter")]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selected,
                    expression: "selected",
                  },
                ],
                staticClass: "form-control",
                on: {
                  change: [
                    function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.selected = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    _vm.getValue,
                  ],
                },
              },
              _vm._l(_vm.parameters, function (p) {
                return _c("option", { key: p, domProps: { value: p } }, [
                  _vm._v(_vm._s(p.ParameterName)),
                ])
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", [_vm._v("Number of Decimal Places")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selected.NumberOfDecimalPoint,
                  expression: "selected.NumberOfDecimalPoint",
                },
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.selected.NumberOfDecimalPoint },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.selected,
                    "NumberOfDecimalPoint",
                    $event.target.value
                  )
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c(
              "button",
              { staticClass: "btn btn-primary", on: { click: _vm.save } },
              [_vm._v("Save")]
            ),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }